import { render, staticRenderFns } from "./Tragos.vue?vue&type=template&id=542b1b89&"
import script from "./Tragos.vue?vue&type=script&lang=js&"
export * from "./Tragos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports